module.exports = __webpack_public_path__ + "static/img/p-up.6435547.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer2/p-up.png
// module id = eEO0
// module chunks = 1